import React, { useState } from "react";
import Button from "../../../components/buttons/Button";
import Dialog from "../../../components/dialog/Dialog";
import Content from "../../../components/Content";
import { useNavigate } from "react-router-dom";
import { ServiceGroupTable } from "../../../components/service/ServiceGroupTable";
import { CreateServiceGroupModal } from "../../../modals/service/CreateServiceGroupModal";
import SearchInput from "../../../components/Inputs/SearchInput";
import { Typography, Box, Card, CardContent } from "@mui/material";

export const ServiceGroupView = () => {
  const navigate = useNavigate();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const clickRow = (id) => {
    navigate(`./overview/${id}`);
  };

  return (
    <>
      <Content title={"Tjänstegrupp"}>
        <Box sx={{ p: 3 }}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Tjänstegrupp
                </Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <SearchInput />
                  <Button onClick={() => setIsCreateModalOpen(true)}>
                    Skapa Ny Tjänstegrupp
                  </Button>
                </Box>
              </Box>
              <Typography variant="body1" color="text.secondary">
                Hantera tjänstegrupper för din organisation. Organisera tjänster i grupper för bättre struktur och hantering. Varje tjänstegrupp kan innehålla flera relaterade tjänster.
              </Typography>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <ServiceGroupTable handleSelect={(item) => clickRow(item.id)} />
            </CardContent>
          </Card>
        </Box>
          <Dialog
            open={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
            title="Skapa Tjänstegrupp"
          >
            <CreateServiceGroupModal
              closeCreateModal={() => setIsCreateModalOpen(false)}
            />
          </Dialog>
      </Content>
    </>
  );
};
